import { SubordinateState, SubordinateFilters } from './interfaces';

export const initialFilters: SubordinateFilters = {
  reviewCycleIds: null,
  userName: '',
  careerMentorIds: null,
  scorecardStatuses: null,
};

export const subordinateScorecardInitialState: SubordinateState = {
  items: [],
  loading: false,
  filters: { ...initialFilters },
  pagination: {
    limit: 0,
    page: 1,
    total: 0,
  },
  init: false,
  fullData: {},
  careerMentorOptions: [],
};

export const storeName = 'scorecardsSubordinates' as const;

export type SubordinateStoreName = typeof storeName;
